import { render, staticRenderFns } from "./tabSetting.vue?vue&type=template&id=690e48d1&scoped=true&"
import script from "./tabSetting.vue?vue&type=script&lang=js&"
export * from "./tabSetting.vue?vue&type=script&lang=js&"
import style0 from "./tabSetting.vue?vue&type=style&index=0&id=690e48d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e48d1",
  null
  
)

export default component.exports